'use strict';

var QaDetailController = /*@ngInject*/ function(
  $state,
  $stateParams,
  JobService,
  ColorReferenceService,
  META_STATUS,
  SearchService,
  Session,
  NotificationService,
  OutreachService,
  RouterTracker,
  ReactNavigationService,
  COLOR_REFERENCE
) {
  var _self = this;
  _self.colorReferences = [];
  _self.error = {
    active: false,
    data: {
      type: 'error',
      heading: {
        title: 'Job Not Found',
        copy: 'This job does not exist, or is no longer in the pipeline.'
      },
      cta: {
        primary: 'Go To Search'
      }
    },
    onSubmit: function() {
      $state.go('search');
    }
  };

  _self.handleReviewCompletion = function($event) {
    var searchParams = {
      term: '*',
      page: 0,
      size: 50,
      sort: 'priority|desc,tasks.startedOn|asc',
      filters:
        'status=' +
        META_STATUS.qa +
        ',processedForSeconds=60' +
        ',assignees=' +
        Session.get('userName')
    };

    _self.working = true;

    SearchService.search(searchParams)
      .then(function(response) {
        // Filter self out from response
        // (The search service updates asyncronously, so it may still appear as "In Image QA")
        var jobs = response.data.results.filter(function(job) {
          return job.id !== $event.job.id;
        });

        // If there is another QA job assignee to the user, load that job data
        // Otherwise, redirect to QA queue
        if (jobs.length) {
          $state.go(
            'qa',
            {
              id: jobs[0].id,
              assetJobId: undefined,
              source: $stateParams.source,
              tab: $stateParams.tab
            },
            {
              location: 'replace'
            }
          );
        } else {
          ReactNavigationService.goToQAQueue();
        }
      })
      .catch(function() {
        ReactNavigationService.goToQAQueue();
      })
      .finally(function() {
        NotificationService.push($event.notification, $event.job);
        _self.working = false;
      });
  };

  _self.initiateProblemSolve = function() {
    _self.showProblemModal = true;
  };

  _self.onMoveToProblemSolve = function() {
    ReactNavigationService.goToQAQueue();
  };

  _self.closeQADetail = function() {
    ReactNavigationService.goToQAQueue();
  };

  _self.updateNotes = function($event) {
    _self.data = $event.job;
  };

  _self.init = function() {
    _self.working = true;

    var previousRoute = RouterTracker.getPreviousState();

    JobService.getJobDetail($stateParams.id, {
      RequestUpdatedProductInfo: true
    })
      .then(function(result) {
        _self.data = result.data;

        const hasFCO = result.data.product.assets.some(asset => asset.viewCode.toLowerCase().startsWith('fco'));
        const useColorReferences = result.data.merchType === 'Product' && result.data.jobType !== 'Variation' && !hasFCO;
        const colorReferencesPromise = useColorReferences
          ? ColorReferenceService.getColorReferencesByJobId(result.data.id)
          : undefined;

        //If the job has review comments and is in Image QA, then bounce to Product Review
        _self.hasReviewComments = false;
        if (_self.data.notes && _self.data.notes.length > 0) {
          _self.hasReviewComments = _self.data.notes.filter(function(a) {
            return a.noteType === 'Product Review';
          });
        }
        var outreachState = OutreachService.getState();

        if (
          _self.data.status === 'In Image QA' &&
          _self.hasReviewComments.length > 0 &&
          previousRoute.route.name !== 'outreach'
        ) {
          OutreachService.setState('image_qa_review');
          $state.go('outreach', {
            id: _self.data.id
          });
        }

        return colorReferencesPromise;
      })
      .then(function(colorReferencesResponse) {
        if (!colorReferencesResponse) {
          _self.colorReferences = undefined;
          return;
        }

        const colorReferences = colorReferencesResponse.data || [];
        _self.colorReferences = colorReferences.sort((a, b) => {
          if (a.type === COLOR_REFERENCE.TYPE.CALCULATED && b.type !== COLOR_REFERENCE.TYPE.CALCULATED) {
            return -1;
          }
          if (b.type === COLOR_REFERENCE.TYPE.CALCULATED && a.type !== COLOR_REFERENCE.TYPE.CALCULATED) {
            return 1;
          }

          if (
            a.type === COLOR_REFERENCE.TYPE.MANUAL &&
            a.override &&
            !(b.type === COLOR_REFERENCE.TYPE.MANUAL && b.override)
          ) {
            return -1;
          }
          if (
            b.type === COLOR_REFERENCE.TYPE.MANUAL &&
            b.override &&
            !(a.type === COLOR_REFERENCE.TYPE.MANUAL && a.override)
          ) {
            return 1;
          }

          return 0;
        });
      })
      .catch(function() {
        _self.error.active = true;
      })
      .finally(function() {
        _self.working = false;
      });
  };

  _self.init();
};

module.exports = QaDetailController;
